export default {
  improvementplans: {
    title: "Plan d'amélioration",
    high: 'Élevé',
    middle: 'Moyen',
    low: 'Faible',
    exceed: 'Dépasser',
    policy: 'Politique',
    measure: 'Action',
    result: 'Résultat',
    currently_supporting: 'En cours',
    completion: 'Terminé',
    ended: 'Incomplet',
    risk: 'Risque',
    thema: "@:{'common.esg.category'}",
    improvement_plan: "Plan d'amélioration",
    deadline_for_completion: 'Délai',
    message_count: 'Message',
    operation: 'Opération',
    detail: "@:{'common.scorecard.detail'}",
    indicator: 'Indicateur',
    indicator_point: "domaine d'amélioration",
    buyer_indicator_point: "Commentaire sur l'évaluation",
    status: 'Statut',
    supported: 'Terminé',
    unsupported: "Pas d'action",
    progress: 'Statut',
    advice: {
      text_line_1: 'Commencez à améliorer votre performance ESG à partir de cette évaluation.',
      text_line_2: '',
      text_line_3: "« Créer un plan d'amélioration » pour fixer des objectifs quant à la réalisation",
      text_line_4: 'des conseils reçus.',
      text_line_5: 'Les progrès peuvent être vérifiés sur le graphique de gauche.',
      text_line_6: 'Si vous souhaitez demander une réévaluation, veuillez',
      contact: 'Nous contacter',
      please_contact_us: '.',
    },
    sub_section_title_1: "Plan d'amélioration en cours",
    no_data_display: "Aucune donnée n'est disponible",
    // sub_section_title_2: "",
    buyer_sub_section_title_2: "Commentaire sur l'évaluation non terminée",
    operation_link_text: "Créer un plan d'amélioration",
    // add_advice: "",
    // sub_section_title_3: "",
    buyer_sub_section_title_3: "Commentaire sur l'évaluation terminée",
    // revaluation_request: "",
    cautionary_note: "Souhaitez-vous demander une réévaluation sur la base de votre plan d'amélioration complété ?",
    asterisked_text: 'Si vous souhaitez demander une réévaluation, veuillez le faire à partir du formulaire de contact.',
    submit_btn_text: 'Demander une réévaluation',
    table_state: 'tableState',
    select_a_file: 'Sélectionner un fichier',
    attached_file: 'Joindre le fichier',
    notes: 'Remarques',
    created_improvement_plan: "Création d'un plan d'amélioration",
    error_file_upload: "Une erreur s'est produite lors du téléchargement du fichier",
    failed_to_create: "La création d'un plan d'amélioration a échoué. Veuillez essayer d'actualiser la page.",
    no_data_found: "Aucune donnée d'amélioration n'a été trouvée.",
    file_upload: {
      filesize_max: 'Veuillez sélectionner des fichiers de moins de 10 Mo.',
      max_files: "Vous pouvez télécharger jusqu'à 10 fichiers.",
      confirmation_of_deletion: 'Voulez-vous supprimer ce fichier ?',
    },
    // create_improvement_plan: "",
    no_data_improvement_plan: "Il n'y a aucun plan d'amélioration actuellement.",
  },
  buyer_improvementplans: {
    flag: 'Marquage',
    memo: 'Mémo',
    flag_on: 'Définir un marquage',
    flag_off: 'Supprimer un marquage',
    panel: {
      title: "Informations sur l'entreprise / Mémo",
      company_memo: "Mémo de l'entreprise",
      latest_memo: 'Dernier mémo',
      no_memo: "Il n'y a pas encore de mémos.",
      check_list: 'Liste de contrôle',
      memo_list: 'Liste des mémos',
      // no_assignee: "",
      assignee_select_box: {
        // assignee: "",
        // placeholder: "",
        // create_member: "",
      },
      create_member_modal: {
        // title: "",
        // label: "",
        // place_holder: "",
      },
      delete_member_modal: {
        // title: "",
        // confirm_text: "",
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: 'Retour à la liste',
    action_cases: 'Cas',
    no_improvements: "Aucun domaine d'amélioration n'a été suggéré",
    confirm_delete_memo: 'Voulez-vous vraiment supprimer ce mémo ?',
    confirm_delete_memo_title: 'Supprimer un mémo',
    // display_only_is_marked: "",
    create_memo: 'Créer un mémo',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
